import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Label } from './ui/label';
import { Baby } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || import.meta.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function DependentLogin() {
  const [babyId, setBabyId] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!babyId.trim()) {
      toast.error('Please enter a Baby ID');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${API}/access/view`, {
        baby_id: babyId.trim()
      });

      const { baby: babyData } = response.data;
      
      // Store baby data in sessionStorage for view-only access
      sessionStorage.setItem('viewOnlyBaby', JSON.stringify(babyData));
      sessionStorage.setItem('viewOnlyMode', JSON.stringify(true));
      sessionStorage.setItem('viewerInfo', JSON.stringify({ name: 'Guest', type: 'guest' }));
      
      toast.success(`Access granted! Loading ${babyData.name}'s dashboard...`);
      
      // Use window.location to force full page reload so App.js checkForExistingBaby runs
      setTimeout(() => {
        window.location.href = '/';
      }, 500);
      
    } catch (error) {
      console.error('Error accessing baby data:', error);
      toast.error(error.response?.data?.detail || 'Invalid Baby ID');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-pink-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'}}>
              <Baby className="w-8 h-8 text-white" />
            </div>
          </div>
          <CardTitle className="text-2xl">Guest Access</CardTitle>
          <CardDescription>
            Enter Baby ID to view health records
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="babyId">Baby ID</Label>
              <Input
                id="babyId"
                name="babyId"
                type="text"
                placeholder="Enter Baby ID (e.g., E99F28AD)"
                value={babyId}
                onChange={(e) => setBabyId(e.target.value.toUpperCase())}
                className="uppercase"
                required
              />
              <p className="text-xs text-gray-500">
                Enter the 8-character Baby ID shared by the parent
              </p>
            </div>

            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? 'Accessing...' : 'View Records'}
            </Button>

            <div className="text-center pt-2 border-t">
              <button
                type="button"
                className="text-sm text-gray-600 hover:underline"
                onClick={() => navigate('/')}
              >
                Back to Home
              </button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}

export default DependentLogin;
